/* eslint-disable @typescript-eslint/no-use-before-define */
import { TAuthConfig } from '@unbooking/ui-auth';

const scope = ['email', 'openid', 'profile'].join(' ');

const authConfig: TAuthConfig = {
  authorizationEndpoint: process.env.REACT_APP_AUTH_AUTHORIZATION_ENDPOINT ?? '',
  clientId: process.env.REACT_APP_AUTH_CLIENT_ID ?? '',
  logoutEndpoint: process.env.REACT_APP_AUTH_LOGOUT_ENDPOINT ?? '',
  logoutUri: maybeAddHost(process.env.REACT_APP_AUTH_LOGOUT_URI),
  redirectUri: maybeAddHost(process.env.REACT_APP_AUTH_REDIRECT_URI),
  tokenEndpoint: process.env.REACT_APP_AUTH_TOKEN_ENDPOINT ?? '',
  refreshTokenEndpoint: process.env.REACT_APP_AUTH_REFRESHTOKEN_ENDPOINT ?? '',
  unbhApiUrl: process.env.REACT_APP_HBH_API ?? '',
  unbhApiKey: process.env.REACT_APP_UNBH_API_KEY ?? '',
  scope,
  configurations: {
    b2c: {
      authorizationEndpoint: process.env.REACT_APP_B2C_AUTHORIZATION_ENDPOINT || '',
      tokenEndpoint: process.env.REACT_APP_B2C_TOKEN_ENDPOINT ?? '',
      clientId: process.env.REACT_APP_B2C_CLIENT_ID || '',
      logoutEndpoint: process.env.REACT_APP_B2C_LOGOUT_ENDPOINT ?? '',
      logoutUri: maybeAddHost(process.env.REACT_APP_B2C_LOGOUT_URI),
      scope: `${scope} offline_access`,
    },
    google: {
      authorizationEndpoint: process.env.REACT_APP_GOOGLE_AUTHORIZATION_ENDPOINT ?? '',
      tokenEndpoint: process.env.REACT_APP_GOOGLE_TOKEN_ENDPOINT ?? '',
      clientId: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID ?? '',
      clientSecret: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_SECRET ?? '',
      scope,
    },
  },
};

export default authConfig;

function maybeAddHost(str = '') {
  return /^http/.test(str) ? str : `${window.location.origin}/${str}`.replace(/(?<!:)\/\//g, '/');
}
